var _sodipodiNamedview, _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoThemeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70.40036mm",
    height: "13.47826mm",
    viewBox: "0 0 266.08011 50.941456",
    id: "svg5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    showgrid: "true"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffc100",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f66c0d",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop3"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient2",
    id: "linearGradient3",
    x1: 275.40286,
    y1: 79.573837,
    x2: 364.67599,
    y2: 79.573837,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-276.2977,-54.103112)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "symbol",
    d: "M 17.204749,50.563505 0.45520862,25.470725 17.392949,0.37795218 h 15.0557 l -16.93768,25.09277282 9.78628,14.58506 29.35872,-39.67783282 h 15.43221 l 16.93772,25.09277282 -16.93772,25.09278 h -15.0559 l 16.93772,-25.09278 -9.78609,-14.428343 -29.17055,39.521123 z",
    fill: "#1c1b1f",
    style: {
      fill: "url(#linearGradient3)",
      stroke: "#210d33",
      strokeWidth: 0.755906,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    style: {
      display: "inline"
    },
    transform: "translate(-267.29697,-70.818755)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: 32,
      lineHeight: 0,
      fontFamily: "'mont bold'",
      InkscapeFontSpecification: "'mont bold, '",
      letterSpacing: "0.195px",
      whiteSpace: "pre",
      inlineSize: 149.427,
      fill: "#210d33",
      strokeWidth: 0.75
    },
    d: "m 270.86681,-703.59057 q -3.904,0 -6.304,-2.048 -2.368,-2.08 -2.368,-5.664 h 4.896 q 0,0.8 0.288,1.44 0.32,0.608 0.832,0.992 0.544,0.384 1.216,0.576 0.672,0.192 1.408,0.192 1.472,0 2.528,-0.704 1.088,-0.704 1.088,-1.92 0,-0.512 -0.256,-0.896 -0.256,-0.416 -0.608,-0.64 -0.32,-0.256 -1.024,-0.512 -0.672,-0.256 -1.152,-0.384 -0.48,-0.128 -1.44,-0.352 -0.768,-0.192 -1.152,-0.288 -0.384,-0.096 -1.152,-0.32 -0.736,-0.224 -1.152,-0.384 -0.384,-0.192 -1.024,-0.512 -0.64,-0.32 -0.992,-0.64 -0.352,-0.32 -0.8,-0.8 -0.416,-0.48 -0.64,-0.992 -0.224,-0.544 -0.384,-1.216 -0.16,-0.704 -0.16,-1.472 0,-3.2 2.176,-4.96 2.176,-1.76 5.952,-1.76 3.808,0 5.92,1.92 2.144,1.92 2.144,5.28 h -4.8 q 0,-1.376 -0.992,-2.08 -0.96,-0.736 -2.4,-0.736 -1.28,0 -2.24,0.544 -0.928,0.544 -0.928,1.568 0,0.48 0.224,0.864 0.256,0.352 0.576,0.608 0.32,0.224 0.992,0.48 0.672,0.224 1.12,0.352 0.48,0.096 1.408,0.32 1.024,0.256 1.536,0.416 0.512,0.128 1.472,0.48 0.96,0.32 1.472,0.64 0.544,0.32 1.248,0.864 0.704,0.512 1.056,1.152 0.384,0.608 0.64,1.504 0.288,0.864 0.288,1.888 0,2.336 -1.184,4 -1.184,1.664 -3.072,2.432 -1.856,0.768 -4.256,0.768 z m 27.61897,-22.848 v 4.512 h -6.24 v 17.888 h -4.864 v -17.888 h -6.208 v -4.512 z m 15.74699,22.4 -4.352,-7.648 h -3.104 v 7.648 h -4.864 v -22.4 h 9.056 q 2.208,0 4,0.96 1.792,0.928 2.784,2.624 1.024,1.696 1.024,3.84 0,2.144 -1.088,3.872 -1.088,1.728 -2.976,2.624 l 4.96,8.48 z m -7.456,-17.92 v 5.792 h 3.872 q 1.472,0 2.336,-0.8 0.896,-0.8 0.896,-2.08 0,-0.864 -0.384,-1.504 -0.384,-0.672 -1.12,-1.024 -0.736,-0.384 -1.728,-0.384 z m 26.11496,6.208 h 11.936 q -0.032,5.312 -3.232,8.768 -3.2,3.424 -8.224,3.424 -4.96,0 -8.288,-3.296 -3.296,-3.328 -3.296,-8.352 0,-5.056 3.264,-8.384 3.264,-3.328 8.224,-3.328 4.192,0 7.328,2.4 3.136,2.368 3.904,6.144 h -4.992 q -0.48,-1.216 -1.376,-2.08 -0.896,-0.896 -2.144,-1.376 -1.216,-0.48 -2.624,-0.48 -2.976,0 -4.832,1.984 -1.856,1.984 -1.856,5.12 0,2.048 0.832,3.648 0.832,1.6 2.336,2.496 1.536,0.896 3.52,0.896 1.44,0 2.72,-0.48 1.28,-0.48 2.176,-1.344 0.928,-0.896 1.344,-2.016 h -6.72 z m 15.87503,11.712 v -22.4 h 4.864 v 22.4 z",
    id: "use1",
    transform: "matrix(1.8794707,0,0,1.6980985,-131.26157,1311.1593)",
    "aria-label": "STRGI"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoThemeColor);
export default __webpack_public_path__ + "static/media/logo_theme_color.390267478b5950d15df71f811ec1672c.svg";
export { ForwardRef as ReactComponent };